import { render, staticRenderFns } from "./Auth_ErrorMessage.vue?vue&type=template&id=180d68a0&scoped=true&"
import script from "./Auth_ErrorMessage.vue?vue&type=script&lang=js&"
export * from "./Auth_ErrorMessage.vue?vue&type=script&lang=js&"
import style0 from "./Auth_ErrorMessage.vue?vue&type=style&index=0&id=180d68a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "180d68a0",
  null
  
)

export default component.exports